angular.module 'zc.projects'

.directive 'zcSettingStatus', (SettingStatus) ->
  restrict: 'EA'
  scope:
    status: '@'
  template: """<div class="config-status" ng-class="{'config-status-success': completed}">
              <i class="fa fa-check-circle"></i>
            </div>"""
  link: (scope, element, attrs) ->
    scope.SettingStatus = SettingStatus
    scope.$watch 'SettingStatus.statuses', (statuses) ->
      scope.completed = statuses[scope.status]
    , true



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/setting_status.coffee